import { render, staticRenderFns } from "./TaskItemPopup.vue?vue&type=template&id=3c8fbbd0&scoped=true&"
import script from "./TaskItemPopup.vue?vue&type=script&lang=js&"
export * from "./TaskItemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fbbd0",
  null
  
)

export default component.exports